var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgUmpireReports = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2000,
    height: 2006,
    viewBox: "0 0 2000 2006",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6162_194275)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2000,
    height: 2005.92,
    fill: "#D3045C"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2000,
    height: 2006,
    fill: "black",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_6162_194275",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9609 690.127C20.9609 683.591 26.2593 678.293 32.7953 678.293H118.416C124.952 678.293 130.251 683.591 130.251 690.127V1949.34C130.251 1952.61 127.601 1955.26 124.333 1955.26H26.8781C23.6101 1955.26 20.9609 1952.61 20.9609 1949.34V690.127Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.9609 690.127C20.9609 683.591 26.2593 678.293 32.7953 678.293H118.416C124.952 678.293 130.251 683.591 130.251 690.127V1949.34C130.251 1952.61 127.601 1955.26 124.333 1955.26H26.8781C23.6101 1955.26 20.9609 1952.61 20.9609 1949.34V690.127Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7953 682.731H118.416V673.855H32.7953V682.731ZM125.813 690.127V1949.34H134.688V690.127H125.813ZM124.333 1950.82H26.8781V1959.69H124.333V1950.82ZM25.3988 1949.34V690.127H16.5231V1949.34H25.3988ZM26.8781 1950.82C26.0611 1950.82 25.3988 1950.16 25.3988 1949.34H16.5231C16.5231 1955.06 21.1592 1959.69 26.8781 1959.69V1950.82ZM125.813 1949.34C125.813 1950.16 125.151 1950.82 124.333 1950.82V1959.69C130.052 1959.69 134.688 1955.06 134.688 1949.34H125.813ZM118.416 682.731C122.501 682.731 125.813 686.042 125.813 690.127H134.688C134.688 681.14 127.403 673.855 118.416 673.855V682.731ZM32.7953 673.855C23.8084 673.855 16.5231 681.14 16.5231 690.127H25.3988C25.3988 686.042 28.7103 682.731 32.7953 682.731V673.855Z",
    fill: "#D8D8D8",
    fillOpacity: 0.5,
    mask: "url(#path-2-inside-1_6162_194275)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-2_6162_194275",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.276 713.135C199.276 706.599 204.575 701.301 211.111 701.301H302.484C309.02 701.301 314.318 706.599 314.318 713.135V1949.34C314.318 1952.61 311.669 1955.26 308.401 1955.26H205.194C201.926 1955.26 199.276 1952.61 199.276 1949.34V713.135Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M199.276 713.135C199.276 706.599 204.575 701.301 211.111 701.301H302.484C309.02 701.301 314.318 706.599 314.318 713.135V1949.34C314.318 1952.61 311.669 1955.26 308.401 1955.26H205.194C201.926 1955.26 199.276 1952.61 199.276 1949.34V713.135Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.111 705.739H302.484V696.863H211.111V705.739ZM309.88 713.135V1949.34H318.756V713.135H309.88ZM308.401 1950.82H205.194V1959.69H308.401V1950.82ZM203.714 1949.34V713.135H194.838V1949.34H203.714ZM205.194 1950.82C204.377 1950.82 203.714 1950.16 203.714 1949.34H194.838C194.838 1955.06 199.475 1959.69 205.194 1959.69V1950.82ZM309.88 1949.34C309.88 1950.16 309.218 1950.82 308.401 1950.82V1959.69C314.12 1959.69 318.756 1955.06 318.756 1949.34H309.88ZM302.484 705.739C306.569 705.739 309.88 709.05 309.88 713.135H318.756C318.756 704.148 311.471 696.863 302.484 696.863V705.739ZM211.111 696.863C202.124 696.863 194.838 704.148 194.838 713.135H203.714C203.714 709.05 207.026 705.739 211.111 705.739V696.863Z",
    fill: "#D8D8D8",
    fillOpacity: 0.5,
    mask: "url(#path-4-inside-2_6162_194275)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-3_6162_194275",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M389.097 856.937C389.097 850.401 394.395 845.103 400.931 845.103H486.552C493.088 845.103 498.386 850.401 498.386 856.937V1949.34C498.386 1952.61 495.737 1955.26 492.469 1955.26H395.014C391.746 1955.26 389.097 1952.61 389.097 1949.34V856.937Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M389.097 856.937C389.097 850.401 394.395 845.103 400.931 845.103H486.552C493.088 845.103 498.386 850.401 498.386 856.937V1949.34C498.386 1952.61 495.737 1955.26 492.469 1955.26H395.014C391.746 1955.26 389.097 1952.61 389.097 1949.34V856.937Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.931 849.541H486.552V840.665H400.931V849.541ZM493.949 856.937V1949.34H502.824V856.937H493.949ZM492.469 1950.82H395.014V1959.69H492.469V1950.82ZM393.535 1949.34V856.937H384.659V1949.34H393.535ZM395.014 1950.82C394.197 1950.82 393.535 1950.16 393.535 1949.34H384.659C384.659 1955.06 389.295 1959.69 395.014 1959.69V1950.82ZM493.949 1949.34C493.949 1950.16 493.286 1950.82 492.469 1950.82V1959.69C498.188 1959.69 502.824 1955.06 502.824 1949.34H493.949ZM486.552 849.541C490.637 849.541 493.949 852.852 493.949 856.937H502.824C502.824 847.95 495.539 840.665 486.552 840.665V849.541ZM400.931 840.665C391.944 840.665 384.659 847.951 384.659 856.937H393.535C393.535 852.852 396.846 849.541 400.931 849.541V840.665Z",
    fill: "#D8D8D8",
    fillOpacity: 0.5,
    mask: "url(#path-6-inside-3_6162_194275)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-8-inside-4_6162_194275",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M573.164 960.475C573.164 953.94 578.462 948.641 584.998 948.641H676.372C682.908 948.641 688.206 953.94 688.206 960.475V1949.34C688.206 1952.61 685.557 1955.26 682.289 1955.26H579.081C575.813 1955.26 573.164 1952.61 573.164 1949.34V960.475Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M573.164 960.475C573.164 953.94 578.462 948.641 584.998 948.641H676.372C682.908 948.641 688.206 953.94 688.206 960.475V1949.34C688.206 1952.61 685.557 1955.26 682.289 1955.26H579.081C575.813 1955.26 573.164 1952.61 573.164 1949.34V960.475Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.998 953.079H676.372V944.203H584.998V953.079ZM683.768 960.475V1949.34H692.644V960.475H683.768ZM682.289 1950.82H579.081V1959.69H682.289V1950.82ZM577.602 1949.34V960.475H568.726V1949.34H577.602ZM579.081 1950.82C578.264 1950.82 577.602 1950.16 577.602 1949.34H568.726C568.726 1955.06 573.362 1959.69 579.081 1959.69V1950.82ZM683.768 1949.34C683.768 1950.16 683.106 1950.82 682.289 1950.82V1959.69C688.008 1959.69 692.644 1955.06 692.644 1949.34H683.768ZM676.372 953.079C680.457 953.079 683.768 956.39 683.768 960.475H692.644C692.644 951.489 685.359 944.203 676.372 944.203V953.079ZM584.998 944.203C576.012 944.203 568.726 951.489 568.726 960.475H577.602C577.602 956.39 580.913 953.079 584.998 953.079V944.203Z",
    fill: "#D8D8D8",
    fillOpacity: 0.5,
    mask: "url(#path-8-inside-4_6162_194275)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-10-inside-5_6162_194275",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M757.229 1236.58C757.229 1230.04 762.527 1224.74 769.063 1224.74H860.436C866.972 1224.74 872.27 1230.04 872.27 1236.58V1949.34C872.27 1952.61 869.621 1955.26 866.353 1955.26H763.146C759.878 1955.26 757.229 1952.61 757.229 1949.34V1236.58Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M757.229 1236.58C757.229 1230.04 762.527 1224.74 769.063 1224.74H860.436C866.972 1224.74 872.27 1230.04 872.27 1236.58V1949.34C872.27 1952.61 869.621 1955.26 866.353 1955.26H763.146C759.878 1955.26 757.229 1952.61 757.229 1949.34V1236.58Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.063 1229.18H860.436V1220.3H769.063V1229.18ZM867.833 1236.58V1949.34H876.708V1236.58H867.833ZM866.353 1950.82H763.146V1959.69H866.353V1950.82ZM761.666 1949.34V1236.58H752.791V1949.34H761.666ZM763.146 1950.82C762.329 1950.82 761.666 1950.16 761.666 1949.34H752.791C752.791 1955.06 757.427 1959.69 763.146 1959.69V1950.82ZM867.833 1949.34C867.833 1950.16 867.17 1950.82 866.353 1950.82V1959.69C872.072 1959.69 876.708 1955.06 876.708 1949.34H867.833ZM860.436 1229.18C864.521 1229.18 867.833 1232.49 867.833 1236.58H876.708C876.708 1227.59 869.423 1220.3 860.436 1220.3V1229.18ZM769.063 1220.3C760.076 1220.3 752.791 1227.59 752.791 1236.58H761.666C761.666 1232.49 764.978 1229.18 769.063 1229.18V1220.3Z",
    fill: "#D8D8D8",
    fillOpacity: 0.5,
    mask: "url(#path-10-inside-5_6162_194275)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.252 1209.07H773.678L783.827 1180.24H790.275L800.438 1209.07H794.864L787.164 1186.15H786.938L779.252 1209.07ZM779.435 1197.76H794.638V1201.96H779.435V1197.76Z",
    fill: "#D8D8D8",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.614 1187.44L812.914 1209.07H807.283L799.583 1187.44H805.017L809.986 1203.5H810.211L815.194 1187.44H820.614Z",
    fill: "#D8D8D8",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.808 1217.62C830.978 1217.62 829.406 1217.38 828.093 1216.88C826.779 1216.39 825.723 1215.73 824.925 1214.91C824.127 1214.08 823.574 1213.17 823.264 1212.16L827.853 1211.05C828.06 1211.47 828.36 1211.89 828.754 1212.3C829.148 1212.73 829.679 1213.07 830.345 1213.34C831.021 1213.63 831.87 1213.77 832.893 1213.77C834.338 1213.77 835.535 1213.41 836.482 1212.71C837.43 1212.02 837.904 1210.87 837.904 1209.28V1205.18H837.651C837.388 1205.71 837.003 1206.24 836.497 1206.8C835.999 1207.35 835.338 1207.82 834.512 1208.19C833.695 1208.57 832.668 1208.76 831.429 1208.76C829.768 1208.76 828.261 1208.37 826.91 1207.59C825.568 1206.8 824.498 1205.63 823.7 1204.07C822.912 1202.5 822.518 1200.54 822.518 1198.18C822.518 1195.81 822.912 1193.81 823.7 1192.17C824.498 1190.53 825.573 1189.29 826.924 1188.44C828.276 1187.59 829.782 1187.16 831.443 1187.16C832.71 1187.16 833.751 1187.38 834.568 1187.81C835.394 1188.23 836.051 1188.74 836.539 1189.34C837.027 1189.93 837.397 1190.49 837.651 1191.02H837.932V1187.44H842.958V1209.42C842.958 1211.27 842.517 1212.8 841.635 1214.01C840.752 1215.22 839.547 1216.12 838.017 1216.72C836.487 1217.32 834.751 1217.62 832.808 1217.62ZM832.851 1204.76C833.93 1204.76 834.85 1204.49 835.61 1203.97C836.37 1203.44 836.947 1202.69 837.341 1201.7C837.735 1200.72 837.932 1199.53 837.932 1198.16C837.932 1196.79 837.735 1195.6 837.341 1194.58C836.956 1193.56 836.384 1192.76 835.624 1192.2C834.873 1191.63 833.949 1191.34 832.851 1191.34C831.715 1191.34 830.767 1191.64 830.007 1192.23C829.247 1192.82 828.674 1193.63 828.29 1194.66C827.905 1195.69 827.712 1196.85 827.712 1198.16C827.712 1199.48 827.905 1200.64 828.29 1201.63C828.684 1202.62 829.261 1203.39 830.021 1203.94C830.791 1204.49 831.734 1204.76 832.851 1204.76Z",
    fill: "#D8D8D8",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M851.32 1209.37C850.466 1209.37 849.734 1209.07 849.124 1208.47C848.514 1207.87 848.213 1207.14 848.223 1206.28C848.213 1205.43 848.514 1204.71 849.124 1204.11C849.734 1203.51 850.466 1203.21 851.32 1203.21C852.145 1203.21 852.863 1203.51 853.473 1204.11C854.093 1204.71 854.407 1205.43 854.417 1206.28C854.407 1206.85 854.257 1207.37 853.966 1207.84C853.685 1208.31 853.309 1208.69 852.84 1208.97C852.38 1209.24 851.873 1209.37 851.32 1209.37Z",
    fill: "#D8D8D8",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M2091.72 1227.75L-283.897 1227.75",
    stroke: "#ABABAB",
    strokeOpacity: 0.45,
    strokeWidth: 2.95858
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-14-inside-6_6162_194275",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M947.049 1322.86C947.049 1316.32 952.347 1311.02 958.883 1311.02H1044.5C1051.04 1311.02 1056.34 1316.32 1056.34 1322.86V1949.34C1056.34 1952.61 1053.69 1955.26 1050.42 1955.26H952.966C949.698 1955.26 947.049 1952.61 947.049 1949.34V1322.86Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M947.049 1322.86C947.049 1316.32 952.347 1311.02 958.883 1311.02H1044.5C1051.04 1311.02 1056.34 1316.32 1056.34 1322.86V1949.34C1056.34 1952.61 1053.69 1955.26 1050.42 1955.26H952.966C949.698 1955.26 947.049 1952.61 947.049 1949.34V1322.86Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958.883 1315.46H1044.5V1306.58H958.883V1315.46ZM1051.9 1322.86V1949.34H1060.78V1322.86H1051.9ZM1050.42 1950.82H952.966V1959.69H1050.42V1950.82ZM951.487 1949.34V1322.86H942.611V1949.34H951.487ZM952.966 1950.82C952.149 1950.82 951.487 1950.16 951.487 1949.34H942.611C942.611 1955.06 947.247 1959.69 952.966 1959.69V1950.82ZM1051.9 1949.34C1051.9 1950.16 1051.24 1950.82 1050.42 1950.82V1959.69C1056.14 1959.69 1060.78 1955.06 1060.78 1949.34H1051.9ZM1044.5 1315.46C1048.59 1315.46 1051.9 1318.77 1051.9 1322.86H1060.78C1060.78 1313.87 1053.49 1306.58 1044.5 1306.58V1315.46ZM958.883 1306.58C949.896 1306.58 942.611 1313.87 942.611 1322.86H951.487C951.487 1318.77 954.798 1315.46 958.883 1315.46V1306.58Z",
    fill: "#D8D8D8",
    fillOpacity: 0.5,
    mask: "url(#path-14-inside-6_6162_194275)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-16-inside-7_6162_194275",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1131.12 1414.89C1131.12 1408.35 1136.41 1403.06 1142.95 1403.06H1234.32C1240.86 1403.06 1246.16 1408.35 1246.16 1414.89V1949.34C1246.16 1952.61 1243.51 1955.26 1240.24 1955.26H1137.03C1133.77 1955.26 1131.12 1952.61 1131.12 1949.34V1414.89Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1131.12 1414.89C1131.12 1408.35 1136.41 1403.06 1142.95 1403.06H1234.32C1240.86 1403.06 1246.16 1408.35 1246.16 1414.89V1949.34C1246.16 1952.61 1243.51 1955.26 1240.24 1955.26H1137.03C1133.77 1955.26 1131.12 1952.61 1131.12 1949.34V1414.89Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1142.95 1407.49H1234.32V1398.62H1142.95V1407.49ZM1241.72 1414.89V1949.34H1250.6V1414.89H1241.72ZM1240.24 1950.82H1137.03V1959.69H1240.24V1950.82ZM1135.55 1949.34V1414.89H1126.68V1949.34H1135.55ZM1137.03 1950.82C1136.22 1950.82 1135.55 1950.16 1135.55 1949.34H1126.68C1126.68 1955.06 1131.31 1959.69 1137.03 1959.69V1950.82ZM1241.72 1949.34C1241.72 1950.16 1241.06 1950.82 1240.24 1950.82V1959.69C1245.96 1959.69 1250.6 1955.06 1250.6 1949.34H1241.72ZM1234.32 1407.49C1238.41 1407.49 1241.72 1410.81 1241.72 1414.89H1250.6C1250.6 1405.9 1243.31 1398.62 1234.32 1398.62V1407.49ZM1142.95 1398.62C1133.96 1398.62 1126.68 1405.9 1126.68 1414.89H1135.55C1135.55 1410.81 1138.87 1407.49 1142.95 1407.49V1398.62Z",
    fill: "#D8D8D8",
    fillOpacity: 0.5,
    mask: "url(#path-16-inside-7_6162_194275)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-18-inside-8_6162_194275",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1320.93 1472.41C1320.93 1465.88 1326.23 1460.58 1332.77 1460.58H1418.39C1424.92 1460.58 1430.22 1465.88 1430.22 1472.41V1949.34C1430.22 1952.61 1427.57 1955.26 1424.31 1955.26H1326.85C1323.58 1955.26 1320.93 1952.61 1320.93 1949.34V1472.41Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1320.93 1472.41C1320.93 1465.88 1326.23 1460.58 1332.77 1460.58H1418.39C1424.92 1460.58 1430.22 1465.88 1430.22 1472.41V1949.34C1430.22 1952.61 1427.57 1955.26 1424.31 1955.26H1326.85C1323.58 1955.26 1320.93 1952.61 1320.93 1949.34V1472.41Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1332.77 1465.01H1418.39V1456.14H1332.77V1465.01ZM1425.79 1472.41V1949.34H1434.66V1472.41H1425.79ZM1424.31 1950.82H1326.85V1959.69H1424.31V1950.82ZM1325.37 1949.34V1472.41H1316.5V1949.34H1325.37ZM1326.85 1950.82C1326.03 1950.82 1325.37 1950.16 1325.37 1949.34H1316.5C1316.5 1955.06 1321.13 1959.69 1326.85 1959.69V1950.82ZM1425.79 1949.34C1425.79 1950.16 1425.12 1950.82 1424.31 1950.82V1959.69C1430.02 1959.69 1434.66 1955.06 1434.66 1949.34H1425.79ZM1418.39 1465.01C1422.47 1465.01 1425.79 1468.33 1425.79 1472.41H1434.66C1434.66 1463.42 1427.38 1456.14 1418.39 1456.14V1465.01ZM1332.77 1456.14C1323.78 1456.14 1316.5 1463.42 1316.5 1472.41H1325.37C1325.37 1468.33 1328.68 1465.01 1332.77 1465.01V1456.14Z",
    fill: "#D8D8D8",
    fillOpacity: 0.5,
    mask: "url(#path-18-inside-8_6162_194275)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-20-inside-9_6162_194275",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1505 1483.91C1505 1477.38 1510.3 1472.08 1516.84 1472.08H1602.46C1608.99 1472.08 1614.29 1477.38 1614.29 1483.91V1949.34C1614.29 1952.61 1611.64 1955.26 1608.37 1955.26H1510.92C1507.65 1955.26 1505 1952.61 1505 1949.34V1483.91Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1505 1483.91C1505 1477.38 1510.3 1472.08 1516.84 1472.08H1602.46C1608.99 1472.08 1614.29 1477.38 1614.29 1483.91V1949.34C1614.29 1952.61 1611.64 1955.26 1608.37 1955.26H1510.92C1507.65 1955.26 1505 1952.61 1505 1949.34V1483.91Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1516.84 1476.52H1602.46V1467.64H1516.84V1476.52ZM1609.85 1483.91V1949.34H1618.73V1483.91H1609.85ZM1608.37 1950.82H1510.92V1959.69H1608.37V1950.82ZM1509.44 1949.34V1483.91H1500.56V1949.34H1509.44ZM1510.92 1950.82C1510.1 1950.82 1509.44 1950.16 1509.44 1949.34H1500.56C1500.56 1955.06 1505.2 1959.69 1510.92 1959.69V1950.82ZM1609.85 1949.34C1609.85 1950.16 1609.19 1950.82 1608.37 1950.82V1959.69C1614.09 1959.69 1618.73 1955.06 1618.73 1949.34H1609.85ZM1602.46 1476.52C1606.54 1476.52 1609.85 1479.83 1609.85 1483.91H1618.73C1618.73 1474.93 1611.44 1467.64 1602.46 1467.64V1476.52ZM1516.84 1467.64C1507.85 1467.64 1500.56 1474.93 1500.56 1483.91H1509.44C1509.44 1479.83 1512.75 1476.52 1516.84 1476.52V1467.64Z",
    fill: "#D8D8D8",
    fillOpacity: 0.5,
    mask: "url(#path-20-inside-9_6162_194275)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-22-inside-10_6162_194275",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1689.07 1552.94C1689.07 1546.4 1694.37 1541.11 1700.9 1541.11H1786.52C1793.06 1541.11 1798.36 1546.4 1798.36 1552.94V1949.34C1798.36 1952.61 1795.71 1955.26 1792.44 1955.26H1694.99C1691.72 1955.26 1689.07 1952.61 1689.07 1949.34V1552.94Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1689.07 1552.94C1689.07 1546.4 1694.37 1541.11 1700.9 1541.11H1786.52C1793.06 1541.11 1798.36 1546.4 1798.36 1552.94V1949.34C1798.36 1952.61 1795.71 1955.26 1792.44 1955.26H1694.99C1691.72 1955.26 1689.07 1952.61 1689.07 1949.34V1552.94Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1700.9 1545.54H1786.52V1536.67H1700.9V1545.54ZM1793.92 1552.94V1949.34H1802.8V1552.94H1793.92ZM1792.44 1950.82H1694.99V1959.69H1792.44V1950.82ZM1693.51 1949.34V1552.94H1684.63V1949.34H1693.51ZM1694.99 1950.82C1694.17 1950.82 1693.51 1950.16 1693.51 1949.34H1684.63C1684.63 1955.06 1689.27 1959.69 1694.99 1959.69V1950.82ZM1793.92 1949.34C1793.92 1950.16 1793.26 1950.82 1792.44 1950.82V1959.69C1798.16 1959.69 1802.8 1955.06 1802.8 1949.34H1793.92ZM1786.52 1545.54C1790.61 1545.54 1793.92 1548.86 1793.92 1552.94H1802.8C1802.8 1543.95 1795.51 1536.67 1786.52 1536.67V1545.54ZM1700.9 1536.67C1691.92 1536.67 1684.63 1543.95 1684.63 1552.94H1693.51C1693.51 1548.86 1696.82 1545.54 1700.9 1545.54V1536.67Z",
    fill: "#D8D8D8",
    fillOpacity: 0.5,
    mask: "url(#path-22-inside-10_6162_194275)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2091.27 227.291H1287.55C1271.21 227.291 1257.97 240.536 1257.97 256.876V1186.64C1257.97 1202.98 1271.21 1216.22 1287.55 1216.22H2091.27C2107.61 1216.22 2120.85 1202.98 2120.85 1186.64V256.876C2120.85 240.537 2107.61 227.291 2091.27 227.291Z",
    fill: "#540225",
    stroke: "#540225",
    strokeWidth: 35.503,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2187.96 155.812H1189.55C1173.21 155.812 1159.96 169.058 1159.96 185.397V1258.27C1159.96 1274.61 1173.21 1287.86 1189.55 1287.86H2187.96C2204.3 1287.86 2217.54 1274.61 2217.54 1258.27V185.397C2217.54 169.058 2204.3 155.812 2187.96 155.812Z",
    fill: "#540225",
    stroke: "#540225",
    strokeWidth: 35.503,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1994.31 1333.64H1386.54C1378.11 1333.64 1370.08 1337.24 1364.47 1343.52L1275.92 1442.73C1261.11 1459.33 1269.23 1485.72 1290.8 1491.13L1685.08 1589.96C1689.82 1591.15 1694.79 1591.14 1699.54 1589.94L2089.1 1491.2C2110.55 1485.77 2118.66 1459.57 2104.03 1442.96L2016.51 1343.66C2010.89 1337.29 2002.81 1333.64 1994.31 1333.64Z",
    fill: "#540225",
    stroke: "#540225",
    strokeWidth: 35.503,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1177.71 173.563H2199.79V1270.1H1177.71V173.563Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1275.72 245.041H2103.1V1198.47H1275.72V245.041Z",
    fill: "black",
    fillOpacity: 0.1,
    stroke: "#D8D8D8",
    strokeOpacity: 0.5,
    strokeWidth: 4.43787,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1381.24 1351.39H1999.66L2103.52 1469.24L1692.29 1573.46L1276.14 1469.15L1381.24 1351.39Z",
    fill: "black",
    fillOpacity: 0.1,
    stroke: "#D8D8D8",
    strokeOpacity: 0.5,
    strokeWidth: 4.43787,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6162_194275)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-30-inside-11_6162_194275",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2001.13 305.574C2001.13 273.131 2027.43 246.831 2059.87 246.831V246.831C2092.31 246.831 2118.61 273.131 2118.61 305.574V305.574C2118.61 338.017 2092.31 364.317 2059.87 364.317V364.317C2027.43 364.317 2001.13 338.017 2001.13 305.574V305.574Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2001.13 305.574C2001.13 273.131 2027.43 246.831 2059.87 246.831V246.831C2092.31 246.831 2118.61 273.131 2118.61 305.574V305.574C2118.61 338.017 2092.31 364.317 2059.87 364.317V364.317C2027.43 364.317 2001.13 338.017 2001.13 305.574V305.574Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2059.87 359.879C2029.88 359.879 2005.56 335.566 2005.56 305.574H1996.69C1996.69 340.468 2024.98 368.755 2059.87 368.755V359.879ZM2114.18 305.574C2114.18 335.566 2089.86 359.879 2059.87 359.879V368.755C2094.76 368.755 2123.05 340.468 2123.05 305.574H2114.18ZM2059.87 251.268C2089.86 251.268 2114.18 275.582 2114.18 305.574H2123.05C2123.05 270.68 2094.76 242.393 2059.87 242.393V251.268ZM2059.87 242.393C2024.98 242.393 1996.69 270.68 1996.69 305.574H2005.56C2005.56 275.582 2029.88 251.268 2059.87 251.268V242.393Z",
    fill: "#D8D8D8",
    fillOpacity: 0.5,
    mask: "url(#path-30-inside-11_6162_194275)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_6162_194275)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-32-inside-12_6162_194275",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1993.77 724.632C1993.77 692.189 2020.07 665.889 2052.52 665.889V665.889C2084.96 665.889 2111.26 692.189 2111.26 724.632V724.632C2111.26 757.075 2084.96 783.375 2052.52 783.375V783.375C2020.07 783.375 1993.77 757.075 1993.77 724.632V724.632Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1993.77 724.632C1993.77 692.189 2020.07 665.889 2052.52 665.889V665.889C2084.96 665.889 2111.26 692.189 2111.26 724.632V724.632C2111.26 757.075 2084.96 783.375 2052.52 783.375V783.375C2020.07 783.375 1993.77 757.075 1993.77 724.632V724.632Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2052.52 778.937C2022.52 778.937 1998.21 754.624 1998.21 724.632H1989.34C1989.34 759.526 2017.62 787.813 2052.52 787.813V778.937ZM2106.82 724.632C2106.82 754.624 2082.51 778.937 2052.52 778.937V787.813C2087.41 787.813 2115.7 759.526 2115.7 724.632H2106.82ZM2052.52 670.327C2082.51 670.327 2106.82 694.64 2106.82 724.632H2115.7C2115.7 689.738 2087.41 661.451 2052.52 661.451V670.327ZM2052.52 661.451C2017.62 661.451 1989.34 689.738 1989.34 724.632H1998.21C1998.21 694.64 2022.52 670.327 2052.52 670.327V661.451Z",
    fill: "#D8D8D8",
    fillOpacity: 0.5,
    mask: "url(#path-32-inside-12_6162_194275)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_6162_194275)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-34-inside-13_6162_194275",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1280.64 548.186C1280.64 515.743 1306.94 489.443 1339.38 489.443V489.443C1371.83 489.443 1398.13 515.743 1398.13 548.186V548.186C1398.13 580.629 1371.83 606.93 1339.38 606.93V606.93C1306.94 606.93 1280.64 580.629 1280.64 548.186V548.186Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1280.64 548.186C1280.64 515.743 1306.94 489.443 1339.38 489.443V489.443C1371.83 489.443 1398.13 515.743 1398.13 548.186V548.186C1398.13 580.629 1371.83 606.93 1339.38 606.93V606.93C1306.94 606.93 1280.64 580.629 1280.64 548.186V548.186Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1339.38 602.492C1309.39 602.492 1285.08 578.178 1285.08 548.186H1276.2C1276.2 583.08 1304.49 611.367 1339.38 611.367V602.492ZM1393.69 548.186C1393.69 578.178 1369.38 602.492 1339.38 602.492V611.367C1374.28 611.367 1402.57 583.08 1402.57 548.186H1393.69ZM1339.38 493.881C1369.38 493.881 1393.69 518.194 1393.69 548.186H1402.57C1402.57 513.292 1374.28 485.005 1339.38 485.005V493.881ZM1339.38 485.005C1304.49 485.005 1276.2 513.292 1276.2 548.186H1285.08C1285.08 518.194 1309.39 493.881 1339.38 493.881V485.005Z",
    fill: "#D8D8D8",
    fillOpacity: 0.5,
    mask: "url(#path-34-inside-13_6162_194275)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_6162_194275)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-36-inside-14_6162_194275",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M989.824 280.296C989.824 247.853 1016.12 221.553 1048.57 221.553V221.553C1081.01 221.553 1107.31 247.853 1107.31 280.296V280.296C1107.31 312.739 1081.01 339.039 1048.57 339.039V339.039C1016.12 339.039 989.824 312.739 989.824 280.296V280.296Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M989.824 280.296C989.824 247.853 1016.12 221.553 1048.57 221.553V221.553C1081.01 221.553 1107.31 247.853 1107.31 280.296V280.296C1107.31 312.739 1081.01 339.039 1048.57 339.039V339.039C1016.12 339.039 989.824 312.739 989.824 280.296V280.296Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1048.57 334.602C1018.58 334.602 994.262 310.288 994.262 280.296H985.386C985.386 315.19 1013.67 343.477 1048.57 343.477V334.602ZM1102.87 280.296C1102.87 310.288 1078.56 334.602 1048.57 334.602V343.477C1083.46 343.477 1111.75 315.19 1111.75 280.296H1102.87ZM1048.57 225.991C1078.56 225.991 1102.87 250.304 1102.87 280.296H1111.75C1111.75 245.402 1083.46 217.115 1048.57 217.115V225.991ZM1048.57 217.115C1013.67 217.115 985.386 245.402 985.386 280.296H994.262C994.262 250.304 1018.58 225.991 1048.57 225.991V217.115Z",
    fill: "#D8D8D8",
    fillOpacity: 0.5,
    mask: "url(#path-36-inside-14_6162_194275)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_6162_194275)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-38-inside-15_6162_194275",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1201.69 76.9059C1201.69 44.4629 1227.99 18.1626 1260.43 18.1626V18.1626C1292.88 18.1626 1319.18 44.4629 1319.18 76.9059V76.9059C1319.18 109.349 1292.88 135.649 1260.43 135.649V135.649C1227.99 135.649 1201.69 109.349 1201.69 76.9059V76.9059Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1201.69 76.9059C1201.69 44.4629 1227.99 18.1626 1260.43 18.1626V18.1626C1292.88 18.1626 1319.18 44.4629 1319.18 76.9059V76.9059C1319.18 109.349 1292.88 135.649 1260.43 135.649V135.649C1227.99 135.649 1201.69 109.349 1201.69 76.9059V76.9059Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1260.43 131.211C1230.44 131.211 1206.13 106.898 1206.13 76.9059H1197.25C1197.25 111.8 1225.54 140.087 1260.43 140.087V131.211ZM1314.74 76.9059C1314.74 106.898 1290.42 131.211 1260.43 131.211V140.087C1295.33 140.087 1323.61 111.8 1323.61 76.9059H1314.74ZM1260.43 22.6005C1290.42 22.6005 1314.74 46.9139 1314.74 76.9059H1323.61C1323.61 42.0119 1295.33 13.7247 1260.43 13.7247V22.6005ZM1260.43 13.7247C1225.54 13.7247 1197.25 42.0119 1197.25 76.9059H1206.13C1206.13 46.9139 1230.44 22.6005 1260.43 22.6005V13.7247Z",
    fill: "#D8D8D8",
    fillOpacity: 0.5,
    mask: "url(#path-38-inside-15_6162_194275)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_6162_194275)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-40-inside-16_6162_194275",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1515.9 1268.67C1515.9 1236.23 1542.2 1209.93 1574.64 1209.93V1209.93C1607.09 1209.93 1633.39 1236.23 1633.39 1268.67V1268.67C1633.39 1301.12 1607.09 1327.42 1574.64 1327.42V1327.42C1542.2 1327.42 1515.9 1301.12 1515.9 1268.67V1268.67Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1515.9 1268.67C1515.9 1236.23 1542.2 1209.93 1574.64 1209.93V1209.93C1607.09 1209.93 1633.39 1236.23 1633.39 1268.67V1268.67C1633.39 1301.12 1607.09 1327.42 1574.64 1327.42V1327.42C1542.2 1327.42 1515.9 1301.12 1515.9 1268.67V1268.67Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1574.64 1322.98C1544.65 1322.98 1520.34 1298.66 1520.34 1268.67H1511.46C1511.46 1303.57 1539.75 1331.85 1574.64 1331.85V1322.98ZM1628.95 1268.67C1628.95 1298.66 1604.63 1322.98 1574.64 1322.98V1331.85C1609.54 1331.85 1637.82 1303.57 1637.82 1268.67H1628.95ZM1574.64 1214.37C1604.63 1214.37 1628.95 1238.68 1628.95 1268.67H1637.82C1637.82 1233.78 1609.54 1205.49 1574.64 1205.49V1214.37ZM1574.64 1205.49C1539.75 1205.49 1511.46 1233.78 1511.46 1268.67H1520.34C1520.34 1238.68 1544.65 1214.37 1574.64 1214.37V1205.49Z",
    fill: "#D8D8D8",
    fillOpacity: 0.5,
    mask: "url(#path-40-inside-16_6162_194275)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_6162_194275)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-42-inside-17_6162_194275",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1743.81 1356.89C1743.81 1324.45 1770.11 1298.15 1802.55 1298.15V1298.15C1834.99 1298.15 1861.3 1324.45 1861.3 1356.89V1356.89C1861.3 1389.34 1834.99 1415.64 1802.55 1415.64V1415.64C1770.11 1415.64 1743.81 1389.34 1743.81 1356.89V1356.89Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1743.81 1356.89C1743.81 1324.45 1770.11 1298.15 1802.55 1298.15V1298.15C1834.99 1298.15 1861.3 1324.45 1861.3 1356.89V1356.89C1861.3 1389.34 1834.99 1415.64 1802.55 1415.64V1415.64C1770.11 1415.64 1743.81 1389.34 1743.81 1356.89V1356.89Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1802.55 1411.2C1772.56 1411.2 1748.25 1386.89 1748.25 1356.89H1739.37C1739.37 1391.79 1767.66 1420.07 1802.55 1420.07V1411.2ZM1856.86 1356.89C1856.86 1386.89 1832.54 1411.2 1802.55 1411.2V1420.07C1837.45 1420.07 1865.73 1391.79 1865.73 1356.89H1856.86ZM1802.55 1302.59C1832.54 1302.59 1856.86 1326.9 1856.86 1356.89H1865.73C1865.73 1322 1837.45 1293.71 1802.55 1293.71V1302.59ZM1802.55 1293.71C1767.66 1293.71 1739.37 1322 1739.37 1356.89H1748.25C1748.25 1326.9 1772.56 1302.59 1802.55 1302.59V1293.71Z",
    fill: "#D8D8D8",
    fillOpacity: 0.5,
    mask: "url(#path-42-inside-17_6162_194275)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_6162_194275)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-44-inside-18_6162_194275",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1515.9 1224.56C1515.9 1192.12 1542.2 1165.82 1574.64 1165.82V1165.82C1607.09 1165.82 1633.39 1192.12 1633.39 1224.56V1224.56C1633.39 1257 1607.09 1283.3 1574.64 1283.3V1283.3C1542.2 1283.3 1515.9 1257 1515.9 1224.56V1224.56Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1515.9 1224.56C1515.9 1192.12 1542.2 1165.82 1574.64 1165.82V1165.82C1607.09 1165.82 1633.39 1192.12 1633.39 1224.56V1224.56C1633.39 1257 1607.09 1283.3 1574.64 1283.3V1283.3C1542.2 1283.3 1515.9 1257 1515.9 1224.56V1224.56Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1574.64 1278.87C1544.65 1278.87 1520.34 1254.55 1520.34 1224.56H1511.46C1511.46 1259.45 1539.75 1287.74 1574.64 1287.74V1278.87ZM1628.95 1224.56C1628.95 1254.55 1604.63 1278.87 1574.64 1278.87V1287.74C1609.54 1287.74 1637.82 1259.45 1637.82 1224.56H1628.95ZM1574.64 1170.26C1604.63 1170.26 1628.95 1194.57 1628.95 1224.56H1637.82C1637.82 1189.67 1609.54 1161.38 1574.64 1161.38V1170.26ZM1574.64 1161.38C1539.75 1161.38 1511.46 1189.67 1511.46 1224.56H1520.34C1520.34 1194.57 1544.65 1170.26 1574.64 1170.26V1161.38Z",
    fill: "#D8D8D8",
    fillOpacity: 0.5,
    mask: "url(#path-44-inside-18_6162_194275)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d_6162_194275)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-46-inside-19_6162_194275",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2015.83 1180.45C2015.83 1148 2042.13 1121.7 2074.57 1121.7V1121.7C2107.01 1121.7 2133.31 1148 2133.31 1180.45V1180.45C2133.31 1212.89 2107.01 1239.19 2074.57 1239.19V1239.19C2042.13 1239.19 2015.83 1212.89 2015.83 1180.45V1180.45Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2015.83 1180.45C2015.83 1148 2042.13 1121.7 2074.57 1121.7V1121.7C2107.01 1121.7 2133.31 1148 2133.31 1180.45V1180.45C2133.31 1212.89 2107.01 1239.19 2074.57 1239.19V1239.19C2042.13 1239.19 2015.83 1212.89 2015.83 1180.45V1180.45Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2074.57 1234.75C2044.58 1234.75 2020.27 1210.44 2020.27 1180.45H2011.39C2011.39 1215.34 2039.68 1243.63 2074.57 1243.63V1234.75ZM2128.88 1180.45C2128.88 1210.44 2104.56 1234.75 2074.57 1234.75V1243.63C2109.46 1243.63 2137.75 1215.34 2137.75 1180.45H2128.88ZM2074.57 1126.14C2104.56 1126.14 2128.88 1150.46 2128.88 1180.45H2137.75C2137.75 1145.55 2109.46 1117.27 2074.57 1117.27V1126.14ZM2074.57 1117.27C2039.68 1117.27 2011.39 1145.55 2011.39 1180.45H2020.27C2020.27 1150.46 2044.58 1126.14 2074.57 1126.14V1117.27Z",
    fill: "#D8D8D8",
    fillOpacity: 0.5,
    mask: "url(#path-46-inside-19_6162_194275)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_d_6162_194275)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-48-inside-20_6162_194275",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2015.83 996.652C2015.83 964.208 2042.13 937.908 2074.57 937.908V937.908C2107.01 937.908 2133.31 964.208 2133.31 996.652V996.652C2133.31 1029.09 2107.01 1055.39 2074.57 1055.39V1055.39C2042.13 1055.39 2015.83 1029.09 2015.83 996.652V996.652Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2015.83 996.652C2015.83 964.208 2042.13 937.908 2074.57 937.908V937.908C2107.01 937.908 2133.31 964.208 2133.31 996.652V996.652C2133.31 1029.09 2107.01 1055.39 2074.57 1055.39V1055.39C2042.13 1055.39 2015.83 1029.09 2015.83 996.652V996.652Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2074.57 1050.96C2044.58 1050.96 2020.27 1026.64 2020.27 996.652H2011.39C2011.39 1031.55 2039.68 1059.83 2074.57 1059.83V1050.96ZM2128.88 996.652C2128.88 1026.64 2104.56 1050.96 2074.57 1050.96V1059.83C2109.46 1059.83 2137.75 1031.55 2137.75 996.652H2128.88ZM2074.57 942.346C2104.56 942.346 2128.88 966.659 2128.88 996.652H2137.75C2137.75 961.758 2109.46 933.47 2074.57 933.47V942.346ZM2074.57 933.47C2039.68 933.47 2011.39 961.758 2011.39 996.652H2020.27C2020.27 966.659 2044.58 942.346 2074.57 942.346V933.47Z",
    fill: "#D8D8D8",
    fillOpacity: 0.5,
    mask: "url(#path-48-inside-20_6162_194275)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_d_6162_194275)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-50-inside-21_6162_194275",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1177.71 724.631C1177.71 692.188 1204.01 665.888 1236.45 665.888V665.888C1268.9 665.888 1295.2 692.188 1295.2 724.631V724.631C1295.2 757.074 1268.9 783.374 1236.45 783.374V783.374C1204.01 783.374 1177.71 757.074 1177.71 724.631V724.631Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1177.71 724.631C1177.71 692.188 1204.01 665.888 1236.45 665.888V665.888C1268.9 665.888 1295.2 692.188 1295.2 724.631V724.631C1295.2 757.074 1268.9 783.374 1236.45 783.374V783.374C1204.01 783.374 1177.71 757.074 1177.71 724.631V724.631Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1236.45 778.937C1206.46 778.937 1182.15 754.623 1182.15 724.631H1173.27C1173.27 759.525 1201.56 787.812 1236.45 787.812V778.937ZM1290.76 724.631C1290.76 754.623 1266.45 778.937 1236.45 778.937V787.812C1271.35 787.812 1299.64 759.525 1299.64 724.631H1290.76ZM1236.45 670.326C1266.45 670.326 1290.76 694.639 1290.76 724.631H1299.64C1299.64 689.737 1271.35 661.45 1236.45 661.45V670.326ZM1236.45 661.45C1201.56 661.45 1173.27 689.737 1173.27 724.631H1182.15C1182.15 694.639 1206.46 670.326 1236.45 670.326V661.45Z",
    fill: "#D8D8D8",
    fillOpacity: 0.5,
    mask: "url(#path-50-inside-21_6162_194275)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_d_6162_194275)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-52-inside-22_6162_194275",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1163.01 1026.06C1163.01 993.616 1189.31 967.315 1221.75 967.315V967.315C1254.19 967.315 1280.49 993.616 1280.49 1026.06V1026.06C1280.49 1058.5 1254.19 1084.8 1221.75 1084.8V1084.8C1189.31 1084.8 1163.01 1058.5 1163.01 1026.06V1026.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1163.01 1026.06C1163.01 993.616 1189.31 967.315 1221.75 967.315V967.315C1254.19 967.315 1280.49 993.616 1280.49 1026.06V1026.06C1280.49 1058.5 1254.19 1084.8 1221.75 1084.8V1084.8C1189.31 1084.8 1163.01 1058.5 1163.01 1026.06V1026.06Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1221.75 1080.36C1191.76 1080.36 1167.45 1056.05 1167.45 1026.06H1158.57C1158.57 1060.95 1186.86 1089.24 1221.75 1089.24V1080.36ZM1276.06 1026.06C1276.06 1056.05 1251.74 1080.36 1221.75 1080.36V1089.24C1256.65 1089.24 1284.93 1060.95 1284.93 1026.06H1276.06ZM1221.75 971.753C1251.74 971.753 1276.06 996.067 1276.06 1026.06H1284.93C1284.93 991.165 1256.65 962.878 1221.75 962.878V971.753ZM1221.75 962.878C1186.86 962.878 1158.57 991.165 1158.57 1026.06H1167.45C1167.45 996.067 1191.76 971.753 1221.75 971.753V962.878Z",
    fill: "#D8D8D8",
    fillOpacity: 0.5,
    mask: "url(#path-52-inside-22_6162_194275)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_d_6162_194275)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-54-inside-23_6162_194275",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1699.7 1224.56C1699.7 1192.12 1726 1165.82 1758.44 1165.82V1165.82C1790.88 1165.82 1817.18 1192.12 1817.18 1224.56V1224.56C1817.18 1257 1790.88 1283.3 1758.44 1283.3V1283.3C1726 1283.3 1699.7 1257 1699.7 1224.56V1224.56Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1699.7 1224.56C1699.7 1192.12 1726 1165.82 1758.44 1165.82V1165.82C1790.88 1165.82 1817.18 1192.12 1817.18 1224.56V1224.56C1817.18 1257 1790.88 1283.3 1758.44 1283.3V1283.3C1726 1283.3 1699.7 1257 1699.7 1224.56V1224.56Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1758.44 1278.87C1728.45 1278.87 1704.13 1254.55 1704.13 1224.56H1695.26C1695.26 1259.45 1723.54 1287.74 1758.44 1287.74V1278.87ZM1812.74 1224.56C1812.74 1254.55 1788.43 1278.87 1758.44 1278.87V1287.74C1793.33 1287.74 1821.62 1259.45 1821.62 1224.56H1812.74ZM1758.44 1170.25C1788.43 1170.25 1812.74 1194.57 1812.74 1224.56H1821.62C1821.62 1189.67 1793.33 1161.38 1758.44 1161.38V1170.25ZM1758.44 1161.38C1723.54 1161.38 1695.26 1189.67 1695.26 1224.56H1704.13C1704.13 1194.57 1728.45 1170.25 1758.44 1170.25V1161.38Z",
    fill: "#D8D8D8",
    fillOpacity: 0.5,
    mask: "url(#path-54-inside-23_6162_194275)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6162_194275",
    x: 1971.83,
    y: 227.299,
    width: 176.081,
    height: 176.081,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9.76573
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.6486
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6162_194275"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6162_194275",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_6162_194275",
    x: 1964.48,
    y: 646.357,
    width: 176.081,
    height: 176.081,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9.76573
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.6486
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6162_194275"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6162_194275",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_6162_194275",
    x: 1251.34,
    y: 469.911,
    width: 176.081,
    height: 176.081,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9.76573
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.6486
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6162_194275"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6162_194275",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_6162_194275",
    x: 960.527,
    y: 202.021,
    width: 176.081,
    height: 176.081,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9.76573
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.6486
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6162_194275"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6162_194275",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_6162_194275",
    x: 1172.39,
    y: -1.36886,
    width: 176.081,
    height: 176.081,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9.76573
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.6486
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6162_194275"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6162_194275",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_6162_194275",
    x: 1486.6,
    y: 1190.4,
    width: 176.081,
    height: 176.081,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9.76573
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.6486
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6162_194275"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6162_194275",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_6162_194275",
    x: 1714.51,
    y: 1278.62,
    width: 176.081,
    height: 176.081,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9.76573
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.6486
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6162_194275"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6162_194275",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_6162_194275",
    x: 1486.6,
    y: 1146.29,
    width: 176.081,
    height: 176.081,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9.76573
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.6486
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6162_194275"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6162_194275",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_6162_194275",
    x: 1986.53,
    y: 1102.17,
    width: 176.081,
    height: 176.081,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9.76573
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.6486
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6162_194275"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6162_194275",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_d_6162_194275",
    x: 1986.53,
    y: 918.377,
    width: 176.081,
    height: 176.081,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9.76573
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.6486
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6162_194275"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6162_194275",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_d_6162_194275",
    x: 1148.41,
    y: 646.356,
    width: 176.081,
    height: 176.081,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9.76573
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.6486
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6162_194275"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6162_194275",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_d_6162_194275",
    x: 1133.71,
    y: 947.784,
    width: 176.081,
    height: 176.081,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9.76573
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.6486
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6162_194275"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6162_194275",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_d_6162_194275",
    x: 1670.4,
    y: 1146.29,
    width: 176.081,
    height: 176.081,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9.76573
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.6486
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6162_194275"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6162_194275",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6162_194275"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2000,
    height: 2005.92,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUmpireReports);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/UmpireReports.c9ab275f868de47ac7a4f7ad46c1521b.svg";